<template>
    <div>
        <v-card class="elevation-12">
            <v-toolbar dark color="secondary">
                <v-spacer></v-spacer>
                <v-toolbar-title>Quote Templates</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn @click="onCreateNewTemplate" small color="primary">Add New Template</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="qteTemplates"
                    hide-actions
                    >
                    <template slot="items" slot-scope="props">
                      <td class="px-1 text-no-wrap">{{ props.item.name }}</td>
                      <td class="px-1">{{ props.item.active }}</td>
                      <td class="px-1 text-xs-center text-no-wrap">{{ props.item.status }}</td>

                        <td>{{props.item.notes}}</td>
                        <td>
                            <v-btn small color="primary" @click="onEditTemplate(props.item)" >Edit</v-btn>
                            <!-- <v-btn small color="primary" @click.prevent="$emit('onDeleteItem', props.item)" >Delete</v-btn> -->
                            <v-btn small color="primary" @click="$router.push({ name: 'admin-quote-template', params: { id: props.item.id } })" >Edit Items</v-btn>
                        </td>
                    </template>
                </v-data-table>

            </v-card-text>
        </v-card>
        <v-dialog v-model="showTemplateAddNewPopup" width="500" height="400">
            <ctlTemplateEdit @onCloseTemplateEdit="onCloseTemplateEdit" :templateData="templateToEdit"
                ></ctlTemplateEdit>
        </v-dialog>
    </div>
</template>
<script>
import ctlTemplateEdit from '@/components/admin/ctlTemplateEdit.vue'
import { mapActions } from 'vuex'
export default {
    // props: ['itemDocs'],
    components: {
        ctlTemplateEdit,
    },
    data() {
        return {
            qteTemplates: [
            ],
            templateSelected: {},
            headers: [
                { text: 'Name', sortable: false},
                { text: 'Active' , sortable: false},
                { text: 'Status' , sortable: false},
                { text: '', sortable: false}
            ],
            templateToEdit: {},
            showTemplateAddNewPopup: false,
        }
    },
    methods: {
        ...mapActions('adminQteTemplate', [
            'searchQuoteTemplates'
        ]),
        async getQteTemplates() {
            this.qteTemplates = await this.searchQuoteTemplates({
                templateId: null,
                active: true
            })
        },
        onCreateNewTemplate() {
            this.templateToEdit = {
                status: 'editing',
                active: true,
            }
            this.showTemplateAddNewPopup = true
        },
        onEditTemplate(tempToEdit) {
            this.templateToEdit = tempToEdit
            this.showTemplateAddNewPopup = true
        },
        onCloseTemplateEdit() {
            this.templateToEdit = {}
            this.showTemplateAddNewPopup = false
            this.getQteTemplates()
        }
    },
    created() {
        this.getQteTemplates()
    }
}
</script>